import Build from "components/Champions/RecommendedBuild/Build";
import ArenaBuild from "components/Champions/RecommendedBuild/ArenaBuild";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { SPECIAL_CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";

export function Overview() {
  const { page } = useChampionProfileContext();

  if (page === SPECIAL_CHAMPION_PAGES.OVERVIEW_ARENA) {
    return <ArenaBuild />;
  }

  return <Build />;
}
